import { SVGProps } from 'react';

const ReflectNetwork = ({ props, size = 64 }: { props?: SVGProps<SVGSVGElement>; size?: string | number }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 64 64" fill="none" {...props}>
    <rect width="64" height="64" fill="#1E1D1D" rx="32" />
    <path fill="#1E1D1D" d="m17.382 17.778.395 28.642 12.84-8.297L47.01 17.779h-29.63Z" />
    <path
      fill="#fff"
      d="m32.392 23.704 5.136 1.185 1.185 1.58-4.148 7.111-8.297 5.136-2.765-3.556v-2.962l1.58-5.729 4.148-2.37 3.16-.395Z"
    />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M45.63 18.37H18.37v27.26l6.649-6.649a9.843 9.843 0 0 1-2.698-6.783c0-5.455 4.422-9.877 9.877-9.877a9.843 9.843 0 0 1 6.783 2.698l6.649-6.649Zm-8.326 8.326a7.506 7.506 0 0 0-10.608 10.608l10.608-10.608ZM16 16v32h32V16H16Z"
      clipRule="evenodd"
    />
    <path fill="#1E1D1D" d="M37.306 26.692a7.506 7.506 0 0 1-10.615 10.616L31.999 32l5.307-5.308Z" />
  </svg>
);

export default ReflectNetwork;
